import { render, staticRenderFns } from "./appDetail.vue?vue&type=template&id=1b721a9c&scoped=true"
import script from "./appDetail.vue?vue&type=script&lang=js"
export * from "./appDetail.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/googlePlayDetailPrefixed.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./appDetail.vue?vue&type=style&index=1&id=1b721a9c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b721a9c",
  null
  
)

export default component.exports